import { useState } from 'react';
import { Link } from 'react-router-dom';
import LoginModal from '../../../components/LoginModal';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false);

  return (
    <>
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center space-x-3 cursor-pointer">
              <div className="w-10 h-10 bg-gradient-to-br from-pink-500 to-purple-500 rounded-lg flex items-center justify-center">
                <i className="ri-graduation-cap-fill text-white text-xl"></i>
              </div>
              <div>
                <div className="font-bold text-gray-900">南湖区AI教育平台</div>
                <div className="text-xs text-pink-600">小学版块</div>
              </div>
            </Link>

            <div className="hidden md:flex items-center space-x-8">
              <a href="#modules" className="text-gray-700 hover:text-pink-600 transition-colors cursor-pointer">功能模块</a>
              <a href="#learning-path" className="text-gray-700 hover:text-pink-600 transition-colors cursor-pointer">学习路径</a>
              <Link to="/" className="text-gray-700 hover:text-pink-600 transition-colors cursor-pointer">返回首页</Link>
            </div>

            <div className="flex items-center gap-4">
              <Link to="/" className="text-sm text-gray-600 hover:text-pink-500 transition-colors cursor-pointer">
                返回首页
              </Link>
              <button 
                onClick={() => setIsLoginOpen(true)}
                className="px-6 py-2 bg-gradient-to-r from-pink-400 to-purple-500 text-white rounded-lg font-semibold hover:shadow-lg transition-all whitespace-nowrap cursor-pointer"
              >
                学生登录
              </button>
            </div>
          </div>
        </div>
      </nav>
      
      <LoginModal 
        isOpen={isLoginOpen}
        onClose={() => setIsLoginOpen(false)}
        userType="primary"
      />
    </>
  );
}
